
import Peer from 'peerjs';
import React, { useEffect, useState } from 'react';
import QRCode from 'react-qr-code';
import { Swiper, SwiperSlide } from 'swiper/react';
import { getCardById } from '../../assets/cards/cards';
import { ReactComponent as Back } from '../../assets/icons/back.svg';
import { ReactComponent as Close } from '../../assets/icons/close.svg';
import { ReactComponent as QRBackground } from '../../assets/icons/qr.svg';
import Page from '../../pages/Page';
import { tag } from '../../services/ATInternetService';
import { addTradedCardToCollection, getCollectionCardById, getSortedCollection, removeFromCollection } from '../../stored/Collection';
import PrimaryButton from '../buttons/primarybutton/PrimaryButton';
import PrimaryIconButton from '../buttons/primaryiconbutton/PrimaryIconButton';
import Card from '../card/Card';
import H1 from '../text/H1';
import H2 from '../text/H2';
import './TradingView.sass';

const idPrefix = 'ntr-hetklokhuis-scanner-';

const getRandomId = () => {
	let id = '';
	while (id.length < 6) {
		id += (Math.floor(Math.random() * 8) + 1).toString();
	}
	return id;
}

let peer = null;

const TradingView = ({ onClosed, tradeQRCode }) => {
	const [cardToSend, setCardToSend] = useState(null);
	const [receivedCardId, setReceivedCardId] = useState(null);

	let card; if (cardToSend) card = getCollectionCardById(JSON.parse(cardToSend.replace('trading:', '')).card).cardId;

	if (!peer) peer = new Peer(`${idPrefix}${getRandomId()}`);

	if (tradeQRCode) {
		const conn = peer.connect(`${idPrefix}${tradeQRCode.id}`, { reliable: true });
		conn.on('error', console.error);
		conn.on('open', () => {
			conn.on('data', (data) => {
				tag.sendClick('trading', {
					name: 'received-card',
				});
				addTradedCardToCollection(JSON.parse(data));
				setReceivedCardId(JSON.parse(data).id);
				setTimeout(() => {
					conn.close();
				}, 150);
				tradeQRCode = null;
			});
			setTimeout(() => {
				conn.send('start:trade');
			}, 100);
		});
	} else {
		peer.on('connection', (conn) => {
			conn.on('open', () => {
				conn.on('data', (data) => {
					if (cardToSend && data === 'start:trade') {
						setTimeout(() => {
							const type = cardToSend.split(':')[0];
							const { card } = JSON.parse(cardToSend.replace(`${type}:`, ''));
							conn.send(JSON.stringify(getCollectionCardById(card)));
							tag.sendClick('trading', {
								chapter3: getCollectionCardById(card).cardId,
								name: 'traded-card',
							});
							removeFromCollection(card);
							onClosed();
						}, 100);
					}
				});
			});
			conn.on('error', console.error);
		});
	}

	useEffect(() => {

	}, [cardToSend, tradeQRCode]);

	return <Page className="tradingview overflow-y-auto z-50 bg-accent-900 flex flex-col content-center justify-center items-center">
		<PrimaryIconButton
			className="tradingview__closebutton absolute right-6 top-6"
			onClick={() => {
				onClosed();
				tag.sendClick('trading', {
					name: 'closed',
				});
			}}>
			<Close />
		</PrimaryIconButton>

		{!tradeQRCode && <>
			<H1 xl noGrow shadow className="text-white mb-6 mt-4 text-center">Kaarten<br />geven</H1>

			{!cardToSend && <>
				<div className="flex-grow overflow-x-auto flex flex-row pb-6" style={{ width: '100vw' }}>
					<Swiper
						// loop
						slidesPerView={2}
						centeredSlides
						spaceBetween={50}>
						{getSortedCollection().map((card) => <SwiperSlide key={card.id}>
							<TradingCard
								card={card}
								peerId={peer.id.replace(idPrefix, '')}
								onClick={(cardInfo) => {
									setCardToSend(cardInfo);
									tag.sendClick('trading', {
										chapter3: card.cardId,
										name: 'selected-card',
									});
								}}
							/>
						</SwiperSlide>)}
					</Swiper>
				</div>
			</>}

			{cardToSend && card && <>
				<PrimaryIconButton
					className="absolute left-6 top-6"
					animated
					onClick={() => setCardToSend(null)}><Back /></PrimaryIconButton>
				{/* eslint-disable-next-line react/no-danger */}
				<style dangerouslySetInnerHTML={{
					__html: `
                .tradingview__qr {
                    background: ${getCardById(card).colors.primary};
                }
                `}}
				/>
				<div className="tradingview__qr p-2 shadow-md bg-white text-center rounded-2xl mx-4" style={{ maxWidth: 'calc(100vw - 2rem)' }}>
					<H1 xl shadow noGrow className="text-white text-center m-4">{getCardById(card).displayName}</H1>
					<div className="bg-black bg-opacity-20 rounded-xl rounded-t-3xl p-4">
						<div className="bg-white rounded-xl py-4">
							<QRBackground />
							<QRCode value={cardToSend} level="Q" />
							<img src={`${window.location.pathname}/favicon.ico`} alt="Klokhuis Scanner Logo" />
						</div>
						<p className="mt-4 max-w-sm font-bold text-white filter drop-shadow-md">
							Scan deze code met de Klokhuis Scanner om de kaart te ontvangen!
						</p>
					</div>
				</div>
			</>}
		</>}

		{tradeQRCode && !receivedCardId && <>
			<H2 className="filter drop-shadow-md text-white font-bold">Kaart ophalen...</H2>
			<p className="filter drop-shadow-md text-white font-bold text-center mt-4 mx-8">Duurt het lang of werkt het niet? Zorg dat je met de zelfde Wi-Fi verbonden bent. Tik op het kruisje om te zien of het ruilen misschien toch gelukt is. </p>
		</>}

		{receivedCardId && <Card
			cardId={getCollectionCardById(receivedCardId).cardId}
			foundAt={getCollectionCardById(receivedCardId).atPlace}
			score={getCollectionCardById(receivedCardId).score}
			centered
			onClick={() => onClosed()}
		/>}

	</Page>
}

const TradingCard = ({ card, peerId, onClick }) => {
	const qrCodeValue = `trading:${JSON.stringify({ id: peerId, card: card.id })}`;
	return <div
		className="tradingview__card__front flex flex-col content-center justify-center items-center h-full"
		style={{ maxWidth: '80vw' }}>
		<div style={{ maxWidth: '80vw' }}>
			<Card
				key={card.id}
				cardId={card.cardId}
				foundAt={card.atPlace}
				score={card.score}
				centered
				onClick={() => onClick(qrCodeValue)}
			/>
		</div>
		<PrimaryButton
			className="mt-4"
			onClick={() => onClick(qrCodeValue)}>Geven</PrimaryButton>
	</div>;
}

export default TradingView;
